import { en } from "../../en.js";

const sanctifiedSkillKeys = Object.fromEntries(
  Object.entries(en)
    .filter(([key]) => key.startsWith("skill."))
    .map(([key, value]) => [`sanctified.${key}`, value])
);

export const sanctifiedEn: Record<string, string> = {
  ...en,
  ...sanctifiedSkillKeys,
};
